module.exports = __webpack_public_path__ + "img/drop-down.79b8ef3e.svg";